.card-title {
  font-weight: 600;
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size-large);
  margin-bottom: var(--title-margin-bottom);
}

.card-menu--content {
  line-height: 18px;
  font-size: var(--body-size);
  color: var(--body-text-arrows-400);
}

$cardWidthSizes: 300, 400, 560;

@each $size in $cardWidthSizes {
  :host([cardWidth='#{$size}']) {
    width: #{$size}px;
  }
}

:host {
  --card-padding-y: calc(var(--spacer) * 2);
  --card-padding-x: calc(var(--spacer) * 4);
  --hover-color: var(--white-layout-302-level-1-elevation);
  --title-margin-bottom: var(--spacer);

  min-height: 250px;
  float: left;
  display: block;
  border-radius: var(--widget-border-radius);
  box-shadow: 0 1px 4px 0 var(--chart-104-pressed);
  padding: var(--card-padding-y) var(--card-padding-x);
  margin-right: calc(var(--spacer) * 4);
  position: relative;
  margin-bottom: calc(var(--spacer) * 4);
  background-color: var(--white-layout-302-level-1-elevation);
  border: 1px solid var(--chart-100-pressed);
}

:host(:hover) {
  background-color: var(--hover-color);
  box-shadow: 4px 4px 6px 0px var(--chart-104-pressed);
  border: 1px solid var(--main-titles-inputs-600);
}

:host([icon]) {
  padding: calc(var(--spacer) * 4) calc(var(--spacer) * 2) 0 calc(var(--spacer) * 2);

  ::part(svgIcon) {
    fill: var(--chart-302-icon-buttons-titles);
  }

  .icon {
    align-self: center;
    padding: calc(var(--spacer) * 3);
  }

  .icon {
    font-size: 26px;
    min-width: 72px;
    height: 72px;
    color: var(--chart-302-icon-buttons-titles);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    margin-right: calc(var(--spacer) * 2);
    border: 1px solid var(--chart-302-icon-buttons-titles);
    margin-top: var(--spacer);
  }

  .circle-svg {
    min-width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    margin-right: calc(var(--spacer) * 2);
    border: 1px solid var(--chart-302-icon-buttons-titles);
    margin-top: var(--spacer);
  }
}

:host([tagInformation]) {
  .tag-container {
    position: absolute;
    justify-content: center;
    align-items: center;
    display: flex;
    top: 0;
    right: 0;
    height: 24px;
    font-size: var(--body-size-small);

    .tag-text {
      display: flex;
      padding: 0 var(--spacer);
      align-items: center;
      background-color: var(--chart-050-hover);
      border-radius: 0 2px 0 2px;
      height: 100%;
      color: var(--main-titles-inputs-600);
    }
  }
}

:host([tagAdditionalInformation]) {
  --aditional-information-color: var(--green-pastel-alert-chart-050-healty);

  .tag-container {
    .tag-additional-information {
      background-color: var(--aditional-information-color);
      height: 100%;
      border-radius: 4px 0 0 4px;
      padding: 0 var(--spacer);
      border: none;
      font-size: inherit;
    }
  }
}
